// LibraryFrame — stacked-cards frame for projectType='library'.
// Shows a z-stacked card hint suggesting a reusable component collection.
// Neutral accent.

export const LibraryFrame = {
  flow: 'column',
  width: '100%',
  height: '100%',
  position: 'relative',
  round: 'inherit',
  overflow: 'visible',
  alignItems: 'center',
  justifyContent: 'center',

  // Ghost stack layers behind main card
  Stack_3: {
    position: 'absolute',
    inset: '0',
    round: 'inherit',
    background: 'white.02',
    border: '1px solid',
    borderColor: 'white.05',
    transform: 'translateY(8px) scale(0.92)',
    zIndex: '-3',
    pointerEvents: 'none',
    overflow: 'hidden'
  },
  Stack_2: {
    position: 'absolute',
    inset: '0',
    round: 'inherit',
    background: 'white.03',
    border: '1px solid',
    borderColor: 'white.07',
    transform: 'translateY(4px) scale(0.96)',
    zIndex: '-2',
    pointerEvents: 'none',
    overflow: 'hidden'
  },

  // Main card surface
  MainCard: {
    position: 'absolute',
    inset: '0',
    round: 'inherit',
    overflow: 'hidden',
    zIndex: '1',
    background: 'black.1',

    // Library-type header strip
    HeaderStrip: {
      flexShrink: '0',
      flow: 'x',
      align: 'center',
      gap: 'V',
      padding: 'V A',
      height: 'A2',
      background: 'black.25',
      borderBottom: '1px solid',
      borderColor: 'white.05',

      Dot: {
        width: 'W',
        height: 'W',
        round: '50%',
        background: 'gray8',
        flexShrink: '0'
      },
      Label: {
        tag: 'span',
        text: 'Library',
        fontSize: 'Z1',
        color: 'white.25',
        fontWeight: '600',
        letterSpacing: '0.04em'
      }
    },

    // Content area
    Content: {
      flexGrow: '1',
      position: 'relative',
      overflow: 'hidden',
      background: 'black.12',

      EmptyState: {
        if: (el, s) => !s.screenshot && !s.screenshotDev && !s.icon,
        position: 'absolute',
        inset: '0',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 'Y',
        pointerEvents: 'none',

        // Mini component grid glyph
        Grid: {
          display: 'grid',
          gridTemplateColumns: 'repeat(3,Y)',
          gridTemplateRows: 'repeat(2,Y)',
          gap: 'W',
          opacity: '0.18',
          Cell_1: { width: 'Y', height: 'Y', round: 'Z', background: 'gray9' },
          Cell_2: { width: 'Y', height: 'Y', round: 'Z', background: 'gray9' },
          Cell_3: { width: 'Y', height: 'Y', round: 'Z', background: 'gray9' },
          Cell_4: { width: 'Y', height: 'Y', round: 'Z', background: 'gray9' },
          Cell_5: { width: 'Y', height: 'Y', round: 'Z', background: 'gray9' },
          Cell_6: { width: 'Y', height: 'Y', round: 'Z', background: 'gray7' }
        },
        Hint: {
          tag: 'span',
          text: 'No exports yet',
          fontSize: 'Z1',
          color: 'white.22',
          fontStyle: 'italic'
        }
      }
    }
  },

  // Neutral gray accent border
  AccentBorder: {
    position: 'absolute',
    top: '0',
    left: '0',
    width: 'V',
    height: '100%',
    background: 'gray8',
    opacity: '0.7',
    pointerEvents: 'none',
    zIndex: '2'
  }
}
